// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c0ce55a4","510":"502b8bbe","865":"4b5701e8"}[chunkId] + ".chunk.js";
};